<!-- components/LoadingIndicator.vue -->
<template>
  <div v-if="isLoading">
    <div class="spinner-border text-primary mb-1 spinner" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingIndicator',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
